export const PUBLIC_DOMAIN = 'https://turnstile.1337707.xyz';
